"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casalnoceto": {
    "984dc5b7": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "skipSearch": false
    }],
    "bossola": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d84a116e": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "skipSearch": false
    }],
    "ca-de-maestri": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e269f80d": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "skipSearch": false
    }],
    "casalsaglio": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6d668a0": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "skipSearch": false
    }],
    "san-carlo": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8bd5f98": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "skipSearch": false
    }],
    "scorticavacca": [{
      "hkey": "40d0c40d",
      "slug": "casalnoceto",
      "name": "Casalnoceto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;